/* globals jQuery, grecaptcha, GRECAPTCHA_CONFIG */

jQuery( $ => {
	const $window = $( window );
	const $document = $( document );
	const $html = $( 'html' );
	const $body = $( 'body' );

	// =========================
	// ! Utilities
	// =========================

	function determineTarget( element, fallbackParent ) {
		const target = $( element ).data( 'toggle' ) || ( $( element ).attr( 'href' ) || '' ).replace( '#', '' );

		if ( ! target && fallbackParent ) {
			return $( element ).closest( fallbackParent );
		}

		return target && $( document.getElementById( target ) );
	}

	function toggleElement( elementOrId, toggle ) {
		if ( ! elementOrId ) {
			return;
		}

		let target, $target;
		if ( typeof elementOrId === 'string' ) {
			target = elementOrId;
			$target = $( document.getElementById( target ) );
		} else {
			$target = $( elementOrId );
			target = $target.attr( 'id' );
		}

		const $toggles = $( `a[href="#${ target }"], [data-toggle="${ target }"]` );

		const className = `show-${ target }`;

		if ( typeof toggle === 'undefined' ) {
			toggle = ! $body.hasClass( className );
		}

		if ( toggle ) {
			$body.addClass( className ).trigger( `toggle:${ target }:on` );
			$target.addClass( 'is-open' ).trigger( 'toggle:on' );
			$toggles.addClass( 'is-active' );
		} else {
			$body.removeClass( className ).trigger( `toggle:${ target }:off` );
			$target.removeClass( 'is-open' ).trigger( 'toggle:off' );
			$toggles.removeClass( 'is-active' );
		}
	}

	// =========================
	// ! Supports Flagging
	// =========================

	$document
		.on( 'touchstart', function() {
			$body.removeClass( 'notouch' ).addClass( 'touch' );
		} )
		.on( 'mousedown', function() {
			$body.addClass( 'using-mouse' );
		} )
		.on( 'keydown', function() {
			$body.removeClass( 'using-mouse' );
		} );

	// =========================
	// ! Toggle Buttons
	// =========================

	$body.on( 'click', '.js-toggle[href^="#"], [rel="toggle"], [data-toggle]', function( e ) {
		if ( this.tagName.toLowerCase() === 'a' ) {
			e.preventDefault();
		}

		const target = $( this ).data( 'toggle' ) || $( this ).attr( 'href' ).replace( '#', '' );

		toggleElement( target );
	} );

	$body.on( 'click', '.js-close', function( e ) {
		e.preventDefault();

		const target = $( this ).parents( '.is-open' ).first().attr( 'id' );

		toggleElement( target, false );
	} );

	// =========================
	// ! Intersection Observers
	// =========================

	if ( typeof IntersectionObserver !== 'undefined' ) {
		// =========================
		// ! - Sticky Header observer
		// =========================

		const $header = $( '.bousfields-header' );
		const $sentinel = $( '.sentinel' );

		const headerObserver = new IntersectionObserver( entries => {
			$header.toggleClass( 'is-sticky', ! entries[ 0 ].isIntersecting );
		} );

		if ( $sentinel.length > 0 ) {
			headerObserver.observe( $sentinel[ 0 ] );
		}

		// =========================
		// ! - Page Nav Scroll Spy
		// =========================

		const offsetHeight = $( 'header' ).outerHeight() || 0;

		const $nav = $( '#navbar' );
		const $navLinks = $nav.find( 'a[href^="#"]' );
		const $navTargets = $navLinks.map( function() {
			return document.querySelector( this.hash );
		} );

		let $lastMatch = null;
		const targetObserver = new IntersectionObserver( changes => {
			changes.forEach( change => {
				$( change.target ).toggleClass( 'in-view', change.isIntersecting );
			} );

			// Find the "current" chunk in view
			let $matches = $navTargets.filter( '.in-view' );

			// In case of multiple, use the first one who's
			// top isn't outside the viewport
			if ( $matches.length > 1 ) {
				$matches = $matches.filter( function() {
					return this.offsetTop >= $window.scrollTop() - offsetHeight;
				} );
			}

			// In case of none, use last chunk
			if ( $matches.length === 0 ) {
				// No fallback, abort
				if ( ! $lastMatch ) {
					return;
				}

				$matches = $lastMatch;
			}

			$navLinks.removeClass( 'is-current' )
				.filter( `a[href="#${ $matches.attr( 'id' ) }"]` )
				.addClass( 'is-current' );

			$lastMatch = $matches;
		}, {
			rootMargin: `${ offsetHeight }px 0px 25%`,
		} );

		$navTargets.each( function() {
			targetObserver.observe( this );
		} );
	}

	// =========================
	// ! Mobile Nav Handling
	// =========================

	$( '.menu a' ).click( function() {
		toggleElement( 'navbar' );
	} );

	// =========================
	// ! Accordion
	// =========================

	$document.on( 'click', '.js-accordion-toggle', function() {
		const $parent = $( this ).closest( '.js-accordion' );
		const $group = $parent.closest( '.js-accordion-group' );
		const $content = $parent.children( '.js-accordion-content' ).first();

		$parent.toggleClass( 'is-active' );
		if ( $parent.hasClass( 'is-active' ) ) {
			$content.addClass( 'is-open' ).stop().hide().animate( { height: 'toggle' }, () => $content.attr( 'style', '' ) );
			$group.find( '.js-accordion' ).not( $parent ).each( function() {
				if ( $( this ).hasClass( 'is-active' ) ) {
					$( this ).removeClass( 'is-active' );
					$( this ).find( '.js-accordion-content' ).stop().show().animate( { height: 'toggle' }, function() {
						$( this ).attr( 'style', '' ).removeClass( 'is-open' );
					} );
				}
			} );
		} else {
			$content.stop().show().animate( { height: 'toggle' }, function() {
				$( this ).attr( 'style', '' ).removeClass( 'is-open' );
			} );
		}
	} );

	// Group adjacent accordions
	$( '.bousfields-accordion' ).each( function() {
		let $group = $( this ).prev( '.bousfields-accordion-group' );
		if ( $group.length === 0 ) {
			$group = $( '<div class="bousfields-accordion-group"></div>' );
			$group.insertBefore( this );
		}

		$( this ).appendTo( $group );
	} );

	// Add classes to accordion/tab blocks automatically
	$( '.bousfields-accordion-group' ).addClass( 'js-accordion-group' );
	$( '.bousfields-accordion' ).addClass( 'js-accordion' );
	$( '.bousfields-accordion__header' ).addClass( 'js-accordion-toggle' );
	$( '.bousfields-accordion__content' ).addClass( 'js-accordion-content' );

	// =========================
	// ! Tab Set
	// =========================

	$document.on( 'click', '.js-tab-trigger', function( e ) {
		e.preventDefault();

		const $toggle = $( this );
		const elements = $toggle.data( 'tabsetData' );

		let $target, $group, $siblings, $targetSiblings;
		if ( elements ) {
			( { $target, $group, $siblings, $targetSiblings } = elements );
		} else {
			$target = determineTarget( this );
			$group = $target.parents( '.js-tab-set' );
			$siblings = $group.find( '.js-tab-trigger' );
			$targetSiblings = $group.find( '.js-tab' );
		}

		$toggle.addClass( 'is-active' );
		$siblings.removeClass( 'is-active' );

		const $current = $targetSiblings.filter( '.is-open' );

		if ( $current.is( $target ) ) {
			return;
		}

		$current.stop().fadeOut( function() {
			$current.removeClass( 'is-open' );
			$target.stop().fadeIn().addClass( 'is-open' );
		} );
	} );

	// Add classes to tab/tabset blocks automatically
	$( '.bousfields-tab-set' ).addClass( 'js-tab-set' );
	$( '.bousfields-tab-set__nav__item' ).addClass( 'js-tab-trigger' );
	$( '.bousfields-tab' ).addClass( 'js-tab' );

	// Mark first tab as auto-open accordion
	$( '.bousfields-tab-set' ).each( function() {
		$( this ).find( '.bousfields-tab' ).first().addClass( 'auto-open' );
	} );

	// =========================
	// ! Accordion/Tab Target handling
	// =========================

	$( window ).on( 'hashchange', function() {
		const target = window.location.hash;

		if ( target.length > 1 && $( target ).hasClass( 'js-accordion' ) ) {
			$( target ).find( '.js-accordion-content' ).trigger( 'click' );
		} else if ( target.length > 1 && $( target ).hasClass( 'js-tab' ) ) {
			$( target ).find( '.js-tab-trigger' ).trigger( 'click' );
		}
	} ).trigger( 'hashchange' );

	// =========================
	// ! In-View Tracking
	// =========================

	if ( typeof IntersectionObserver !== 'undefined' ) {
		const topMargin = $html.css( 'margin-top' ) || '0px';

		const inviewObserver = new IntersectionObserver( changes => {
			changes.forEach( change => {
				if ( change.intersectionRatio > 0 ) {
					$( change.target ).addClass( 'in-view' );
				}
			} );
		}, {
			margin: `${ topMargin }px 0 0`,
		} );

		$( '.page-content' ).children().addClass( 'lazy' ).each( function() {
			inviewObserver.observe( this );
		} );
	}

	// =========================
	// ! Contact Form Submission
	// =========================

	let withRecaptcha = function( data, callback ) {
		callback( data );
	};

	if ( typeof grecaptcha !== 'undefined' && typeof GRECAPTCHA_CONFIG !== 'undefined' ) {
		grecaptcha.ready( () => {
			withRecaptcha = function( data, callback ) {
				grecaptcha.execute( GRECAPTCHA_CONFIG.siteKey, { action: 'homepage' } )
					.then( token => {
						if ( typeof data === 'object' ) {
							data.grecaptcha = token;
						} else {
							data += '&grecaptcha=' + token;
						}
						callback( data );
					} );
			};
		} );
	}

	$( '.bousfields-form' ).submit( function( e ) {
		e.preventDefault();
		const $form = $( this );
		withRecaptcha(
			$( this ).serialize(),
			data => {
				$form.find( '.feedback' ).remove();
				const $feedback = $( '<p class="feedback"></p>' );

				$.ajax( {
					url: this.action,
					method: this.method,
					data,
					dataType: 'json',
					success( response ) {
						if ( response.ok ) {
							$form.after( $feedback.text( response.message ) );
							$form.remove();
							return;
						}

						/* eslint-disable-next-line no-alert */
						alert( 'Unknown error, please try again.' );
						/* eslint-disable-next-line no-console */
						console.log( response );
					},
					error( { responseText, responseJSON } ) {
						if ( ! responseJSON ) {
							/* eslint-disable-next-line no-alert */
							alert( 'Unknown error, please try again.' );
							/* eslint-disable-next-line no-console */
							console.log( responseText );
						}

						if ( responseJSON.message ) {
							$form.append( $feedback.text( responseJSON.message ) );
						}
					},
				} );
			},
		);
	} );

	// =========================
	// ! VH Hack
	// =========================

	function setVH() {
		const vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty( '--vh', `${ vh }px` );
	}

	window.addEventListener( 'resize', setVH );
	setVH();

	// =========================
	// ! Initialize Stuff
	// =========================

	// Open accordions marked auto-open
	$( '.js-accordion.auto-open' ).addClass( 'is-active' ).find( '.js-accordion-content' ).first().addClass( 'is-open' );

	// Open first tab in a set
	$( '.js-tab-set' ).each( function() {
		$( this ).find( '.js-tab-trigger' ).first().addClass( 'is-active' );
		$( this ).find( '.js-tab' ).first().addClass( 'is-open' );
	} );
} );
